module.exports = __webpack_public_path__ + "media/images/button-remove-photo-9f4b9feb.svg";